// noinspection ES6ConvertVarToLetConst
declare var __HOT__: boolean

export function enableDevtools () {
  if (process.env.NODE_ENV !== 'development') return
  if (__HOT__) require('preact/debug/index')
}



// WEBPACK FOOTER //
// ./src/client/utils/devtools.js